import { FC, useMemo } from 'react';

import { Box, Typography } from '@mui/material';

import { PageLoader } from 'components';
import { Footer } from 'layout/Footer';
import { EmptyState, ProductsFiltersWrapper } from './components';
import { useProductsListPage, useFilters } from './hooks';
import { styles } from './styles';

export const ProductsListPage: FC = (): JSX.Element => {
  const { title, searchParam } = useProductsListPage();

  const {
    parsedFilters,
    parsedColors,
    parsedContinents,
    parsedResistances,
    isLoading: isFiltersLoading,
    isMaturityRange,
    isWeightRange,
    isMaturityFilter,
    isOrganicFilter,
    isWeightFilter,
    minWeightLimit,
    maxWeightLimit,
    weightStep,
    minMaturityLimit,
    maxMaturityLimit,
    maturityStep,
  } = useFilters(searchParam);

  const isEmptyResult = useMemo(
    () => parsedColors?.length <= 1 && parsedContinents?.length <= 1,
    // SPZ-1550: update
    // && parsedResistances?.length <= 1
    [parsedColors?.length, parsedContinents?.length],
  );

  return (
    <Box sx={styles.pageWrap}>
      <Typography sx={styles.title}>{title}</Typography>

      {isFiltersLoading ? (
        <Box sx={styles.loaderWrap}>
          <PageLoader />
        </Box>
      ) : (
        <Box sx={styles.productsWrap}>
          {isEmptyResult ? (
            <Box sx={styles.emptyWrap}>
              <EmptyState />
            </Box>
          ) : (
            <ProductsFiltersWrapper
              searchParam={searchParam}
              parsedFilters={parsedFilters}
              parsedColors={parsedColors}
              parsedContinents={parsedContinents}
              parsedResistances={parsedResistances}
              isMaturityFilter={isMaturityFilter}
              isOrganicFilter={isOrganicFilter}
              isWeightFilter={isWeightFilter}
              isMaturityRange={isMaturityRange}
              isWeightRange={isWeightRange}
              minWeightLimit={minWeightLimit}
              maxWeightLimit={maxWeightLimit}
              weightStep={weightStep}
              minMaturityLimit={minMaturityLimit}
              maxMaturityLimit={maxMaturityLimit}
              maturityStep={maturityStep}
            />
          )}
        </Box>
      )}
      {isEmptyResult && (
        <Box sx={styles.footerWrap}>
          <Footer />
        </Box>
      )}
    </Box>
  );
};
